import type { PropsWithChildren, ReactElement } from "react";
import { Row, Text } from "@hightouch/htui";

export const QueryHeader = ({ children }: PropsWithChildren) => {
  return (
    <Row
      align="center"
      px={4}
      py={4}
      bg="base.background"
      borderBottomWidth="hairline"
      borderBottomStyle="solid"
      borderColor="base.divider"
      gap={4}
      justify="space-between"
    >
      {children}
    </Row>
  );
};

export const QueryHeaderTitle = ({
  icon,
  title,
}: {
  icon?: ReactElement;
  title: string;
}) => {
  return (
    <Row align="center" fontSize="lg" gap={2}>
      {icon}
      <Text fontWeight="medium" size="lg">
        {title}
      </Text>
    </Row>
  );
};
